(function() {
  function initCartDrawerShippingCost(priceCostArray, initialWeight, initialTotalPrice) {
    if (!Array.isArray(priceCostArray) || priceCostArray.length === 0) return;
    
    const lastItem = priceCostArray[priceCostArray.length - 1];
    
    function updateShippingCost(cartData) {
      // Obtener el peso total del carrito - siempre usar datos frescos del carrito
      const totalWeight = cartData ? cartData.total_weight : initialWeight;
      // Precio original del carrito SIN shipping (viene de Shopify en centavos)
      const cartTotalPrice = cartData ? cartData.total_price / 100 : initialTotalPrice / 100;
      
      let foundPrice = null;
      
      // Buscar el precio de envío según el peso
      for (let i = 0; i < priceCostArray.length; i++) {
        const item = priceCostArray[i];
        if (totalWeight >= item.min_weight && totalWeight <= item.max_weight) {
          foundPrice = item.price;
          break;
        }
      }
      
      // Si el peso excede el máximo, usar el último precio
      if (foundPrice === null && totalWeight > lastItem.max_weight) {
        foundPrice = lastItem.price;
      }
      
      // Actualizar el elemento de gastos de envío
      const weightElement = document.querySelector('.product__inventory-cost-cart');
      if (weightElement && foundPrice !== null) {
        weightElement.innerHTML = "<span>Gastos de envío:</span>" + "<span>" + foundPrice.toFixed(2).replace('.', ',') + " €</span>";
      }
      
      // Actualizar el total de artículos (sin shipping)
      const totalArticulosElement = document.querySelector('.cart-drawer__total-articulos');
      if (totalArticulosElement) {
        totalArticulosElement.textContent = cartTotalPrice.toFixed(2).replace('.', ',') + " €";
      }
      
      // Actualizar el total del carrito con gastos de envío
      setTimeout(function() {
        const cartTotalPriceContainer = document.querySelector('.drawer__footer-body .totals__subtotal-value');
        if (cartTotalPriceContainer && foundPrice !== null) {
          // Siempre usar el precio original del carrito + shipping
          const totalWithShipping = cartTotalPrice + foundPrice;
          cartTotalPriceContainer.innerHTML = totalWithShipping.toFixed(2).replace('.', ',') + " €";
        }
      }, 100);
    }
    
    // Ejecutar al cargar la página
    updateShippingCost(null);
    
    // Ejecutar cuando se actualiza el carrito
    document.addEventListener('cart:updated', function(event) {
      // Siempre hacer fetch para obtener datos frescos del carrito
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => updateShippingCost(cart))
        .catch(err => console.error('Error fetching cart:', err));
    });
    
    // También escuchar cart:refresh
    document.addEventListener('cart:refresh', function() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => updateShippingCost(cart))
        .catch(err => console.error('Error fetching cart:', err));
    });
  }
  
  // Exponer la función globalmente
  window.initCartDrawerShippingCost = initCartDrawerShippingCost;
})();
